<app-tracked-time-list
  class="unbilled-tracked-time-list"
  [filter]="filter"
  [trackedTimes]="trackedTimes$ | async"
  [noTrackedTimeDescription]="noTrackedTimeDescription"
>
</app-tracked-time-list>
